<mat-form-field class="language-select" [attr.data-cy]="'language-select'">
  @if (translate.currentLang === 'de') {
  <span class="fi fi-de" matPrefix></span>
  } @if (translate.currentLang === 'en') {
  <span class="fi fi-gb" matPrefix></span>
  }

  <mat-select
    hideSingleSelectionIndicator
    panelClass="language-panel"
    [placeholder]="
      translate.currentLang === 'de'
        ? ('LANGUAGE.GERMAN' | translate)
        : ('LANGUAGE.ENGLISH' | translate)
    "
    (selectionChange)="changeLanguage($event.value)"
  >
    <mat-option value="de" [attr.data-cy]="'language-option-de'">
      <span style="margin-right: 10px" class="fi fi-de option-layout"></span>
      {{ 'LANGUAGE.GERMAN' | translate }}
    </mat-option>
    <mat-option value="en" [attr.data-cy]="'language-option-en'">
      <span style="margin-right: 10px" class="fi fi-gb option-layout"></span>
      {{ 'LANGUAGE.ENGLISH' | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>
